module.exports = __webpack_public_path__ + "img/white-play-icon.df8d4588.jpg";